import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import cookies from "js-cookie";
import { locales } from "../utils/constants";

i18next
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // fallbackLng: "am",
        lng: cookies.get("i18next") || "am",
        supportedLngs: locales,
        debug: false,
        nsSeparator: false,
        keySeparator: false,
        react: { useSuspense: false },
        detection: {
            order: ["cookie", "htmlTag"],
            caches: ["cookie"],
        },
        backend: {
            loadPath: "/locales/{{lng}}.json",
        },
    });

export default i18next;
